import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Spinner, Card, InputGroup } from 'react-bootstrap';

import { useForm } from '../../hooks/useForm';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
const initialState = {
    id: '',
    idtk: '',
    asunto: '',
    contenido: '',
    estado: '',
    prioridad: '',
};
const OppTik = ({ tik, callBk }) => {
    const [send, setSend] = useState(false);
    const { setResp } = useContextInfo();

    const [values, handleInputChange, setFormValue] = useForm({
        ...initialState,
    });

    useEffect(() => {
        !tik ? setFormValue({ ...initialState }) : setFormValue({ ...values, ...tik });
    }, [tik]);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSend(true);
        if (send) return;

        const resp = await fetchConToken(`tickets/editsuport`, { ...values, cl: tik.idcliente }, 'PUT');
        setResp(resp);
        callBk();
        setSend(false);
    };
    return (
        <Card className="p-3">
            <Form noValidate onSubmit={onSubmit}>
                <Row>
                    <Col xl="auto">
                        {' '}
                        <Form.Group className="mb-3" controlId="validationCustom19">
                            <Form.Label>Estado</Form.Label>
                            <Form.Select value={values.estado} name="estado" required onChange={handleInputChange}>
                                <option value="open">Abierto</option>
                                <option value="reply">Contestado</option>
                                <option value="close">Cerrado</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xl="auto">
                        {' '}
                        <Form.Group className="mb-3" controlId="validationCustom19">
                            <Form.Label>Prioridad</Form.Label>
                            <Form.Select
                                value={values.prioridad}
                                name="prioridad"
                                required
                                onChange={handleInputChange}>
                                <option value="ALTA">ALTA</option>
                                <option value="NORMAL">NORMAL</option>
                                <option value="BAJA">BAJA</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col>
                        {' '}
                        <Form.Group className="mb-3" controlId="validationCustom17">
                            <Form.Label>Asunto</Form.Label>
                            <Form.Control
                                type="text"
                                value={values.asunto}
                                name="asunto"
                                onChange={handleInputChange}
                            />
                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                        </Form.Group>{' '}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3" controlId="validationCustom17">
                            <Form.Label> Detalles del ticket</Form.Label>

                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    as={'textarea'}
                                    value={values.contenido}
                                    name="contenido"
                                    onChange={handleInputChange}
                                />{' '}
                            </InputGroup>
                        </Form.Group>{' '}
                    </Col>
                </Row>

                {send ? (
                    <Button color="primary" disabled>
                        <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                        Guardando...
                    </Button>
                ) : (
                    <Button type="submit">Guardar cambios</Button>
                )}
            </Form>{' '}
        </Card>
    );
};

export default OppTik;
